import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Import_process_logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.import_process_logs_Id,
          sortable: true,
          cell: (row) => <span>{row.import_process_logs_Id}</span>,
        },
        { name: "Import Session Id", selector: (row, i) => row.import_session_id, sortable: true, cell: (row) => <span>{row.import_session_id}</span>, }, { name: "Row Number", selector: (row, i) => row.row_number, sortable: true, cell: (row) => <span>{row.row_number}</span>, }, { name: "Excel Row Data", selector: (row, i) => row.excel_row_data, sortable: true, cell: (row) => <span>{row.excel_row_data}</span>, }, { name: "Mapped Data", selector: (row, i) => row.mapped_data, sortable: true, cell: (row) => <span>{row.mapped_data}</span>, }, { name: "Validation Errors", selector: (row, i) => row.validation_errors, sortable: true, cell: (row) => <span>{row.validation_errors}</span>, }, { name: "Operation Type", selector: (row, i) => row.operation_type, sortable: true, cell: (row) => <span>{row.operation_type}</span>, }, { name: "Operation Status", selector: (row, i) => row.operation_status, sortable: true, cell: (row) => <span>{row.operation_status}</span>, }, { name: "Record Id", selector: (row, i) => row.record_id, sortable: true, cell: (row) => <span>{row.record_id}</span>, }, { name: "Error Code", selector: (row, i) => row.error_code, sortable: true, cell: (row) => <span>{row.error_code}</span>, }, { name: "Error Message", selector: (row, i) => row.error_message, sortable: true, cell: (row) => <span>{row.error_message}</span>, }, { name: "Processing Time Ms", selector: (row, i) => row.processing_time_ms, sortable: true, cell: (row) => <span>{row.processing_time_ms}</span>, },

        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Import_process_logseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      import_process_logs_Id: "",
      import_session_id: '', row_number: '', excel_row_data: '', mapped_data: '', validation_errors: '', bulkimportoperationtypemaster: [], operation_type: '', bulkimportoperationstatusmaster: [], operation_status: '', record_id: '', error_code: '', error_message: '', processing_time_ms: '',

    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'import_session_id', inputType: 'Number', displayName: 'Import Session Id', validationOptions: { isRequired: false } },
      { fieldName: 'row_number', inputType: 'Number', displayName: 'Row Number', validationOptions: { isRequired: false } },
      { fieldName: 'excel_row_data', inputType: 'Text', displayName: 'Excel Row Data', validationOptions: { isRequired: false } },
      { fieldName: 'mapped_data', inputType: 'Text', displayName: 'Mapped Data', validationOptions: { isRequired: false } },
      { fieldName: 'validation_errors', inputType: 'Text', displayName: 'Validation Errors', validationOptions: { isRequired: false } },
      { fieldName: 'operation_type', inputType: 'Select', displayName: 'Operation Type', validationOptions: { isRequired: false } },
      { fieldName: 'operation_status', inputType: 'Select', displayName: 'Operation Status', validationOptions: { isRequired: false } },
      { fieldName: 'record_id', inputType: 'Number', displayName: 'Record Id', validationOptions: { isRequired: false } },
      { fieldName: 'error_code', inputType: 'Text', displayName: 'Error Code', validationOptions: { isRequired: false } },
      { fieldName: 'error_message', inputType: 'Text', displayName: 'Error Message', validationOptions: { isRequired: false } },
      { fieldName: 'processing_time_ms', inputType: 'Number', displayName: 'Processing Time Ms', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      import_session_id: '', row_number: '', excel_row_data: '', mapped_data: '', validation_errors: '', bulkimportoperationtypemaster: [], operation_type: '', bulkimportoperationstatusmaster: [], operation_status: '', record_id: '', error_code: '', error_message: '', processing_time_ms: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      import_session_id: '', row_number: '', excel_row_data: '', mapped_data: '', validation_errors: '', bulkimportoperationtypemaster: [], operation_type: '', bulkimportoperationstatusmaster: [], operation_status: '', record_id: '', error_code: '', error_message: '', processing_time_ms: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Import_process_logseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      import_process_logs_Id: row.import_process_logs_Id,
      import_session_id: row.import_session_id, row_number: row.row_number, excel_row_data: row.excel_row_data, mapped_data: row.mapped_data, validation_errors: row.validation_errors, bulkimportoperationtypemaster: [], operation_type: row.operation_type, bulkimportoperationstatusmaster: [], operation_status: row.operation_status, record_id: row.record_id, error_code: row.error_code, error_message: row.error_message, processing_time_ms: row.processing_time_ms,

      errors: {},
      touched: {}
    });
  }

  Import_process_logsfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Import_process_logs/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Import_process_logssubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('import_session_id', this.state.import_session_id);
    formData.append('row_number', this.state.row_number);
    formData.append('excel_row_data', this.state.excel_row_data);
    formData.append('mapped_data', this.state.mapped_data);
    formData.append('validation_errors', this.state.validation_errors);
    formData.append('operation_type', this.state.operation_type);
    formData.append('operation_status', this.state.operation_status);
    formData.append('record_id', this.state.record_id);
    formData.append('error_code', this.state.error_code);
    formData.append('error_message', this.state.error_message);
    formData.append('processing_time_ms', this.state.processing_time_ms);



    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Import_process_logs/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_process_logsfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ import_session_id: '', row_number: '', excel_row_data: '', mapped_data: '', validation_errors: '', bulkimportoperationtypemaster: [], operation_type: '', bulkimportoperationstatusmaster: [], operation_status: '', record_id: '', error_code: '', error_message: '', processing_time_ms: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Import_process_logsupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("import_process_logs_Id", this.state.import_process_logs_Id);
    formData.append('import_session_id', this.state.import_session_id);
    formData.append('row_number', this.state.row_number);
    formData.append('excel_row_data', this.state.excel_row_data);
    formData.append('mapped_data', this.state.mapped_data);
    formData.append('validation_errors', this.state.validation_errors);
    formData.append('operation_type', this.state.operation_type);
    formData.append('operation_status', this.state.operation_status);
    formData.append('record_id', this.state.record_id);
    formData.append('error_code', this.state.error_code);
    formData.append('error_message', this.state.error_message);
    formData.append('processing_time_ms', this.state.processing_time_ms);



    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Import_process_logs/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_process_logsfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Import_process_logsfetchHandler();
    this.bulkimportoperationtypemasterfetchHandler();
    this.bulkimportoperationstatusmasterfetchHandler();


  }

  handleimport_session_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ import_session_id: fieldValue });
  }; handlerow_numberChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ row_number: fieldValue });
  }; handleexcel_row_dataChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ excel_row_data: fieldValue });
  }; handlemapped_dataChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ mapped_data: fieldValue });
  }; handlevalidation_errorsChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ validation_errors: fieldValue });
  }; handleoperation_typeChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ operation_type: fieldValue });
  }; bulkimportoperationtypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Bulkimportoperationtypemaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ bulkimportoperationtypemaster: data.list });
        }
      });
  }; handleoperation_statusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ operation_status: fieldValue });
  }; bulkimportoperationstatusmasterfetchHandler = () => {
    fetch(configData.api_url + "C_Bulkimportoperationstatusmaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ bulkimportoperationstatusmaster: data.list });
        }
      });
  }; handlerecord_idChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ record_id: fieldValue });
  }; handleerror_codeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ error_code: fieldValue });
  }; handleerror_messageChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ error_message: fieldValue });
  }; handleprocessing_time_msChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ processing_time_ms: fieldValue });
  };


  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this import_process_logs?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('import_process_logs_Id', row.import_process_logs_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Import_process_logs/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Import_process_logsfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Import Process Logs</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Import_process_logs</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Import Session Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleimport_session_idChange} className="form-control" name="import_session_id" value={this.state.import_session_id} required="required" placeholder="Enter import_session_id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.import_session_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Row Number</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlerow_numberChange} className="form-control" name="row_number" value={this.state.row_number} required="required" placeholder="Enter row_number" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.row_number} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Excel Row Data</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleexcel_row_dataChange} className="form-control" name="excel_row_data" value={this.state.excel_row_data} required="required" placeholder="Enter excel_row_data" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.excel_row_data} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Mapped Data</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemapped_dataChange} className="form-control" name="mapped_data" value={this.state.mapped_data} required="required" placeholder="Enter mapped_data" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapped_data} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Validation Errors</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlevalidation_errorsChange} className="form-control" name="validation_errors" value={this.state.validation_errors} required="required" placeholder="Enter validation_errors" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.validation_errors} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Operation Type</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleoperation_typeChange}>
                                        <option defaultValue> Select Operation Type </option>
                                        {this.state.bulkimportoperationtypemaster.map((api, index, idx) => (
                                          <option key={index} value={api.insert}> {api.insert} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.operation_type} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Operation Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handleoperation_statusChange}>
                                        <option defaultValue> Select Operation Status </option>
                                        {this.state.bulkimportoperationstatusmaster.map((api, index, idx) => (
                                          <option key={index} value={api.success}> {api.success} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.operation_status} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Record Id</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlerecord_idChange} className="form-control" name="record_id" value={this.state.record_id} required="required" placeholder="Enter record_id" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.record_id} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Error Code</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleerror_codeChange} className="form-control" name="error_code" value={this.state.error_code} required="required" placeholder="Enter error_code" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_code} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter error_message" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Processing Time Ms</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handleprocessing_time_msChange} className="form-control" name="processing_time_ms" value={this.state.processing_time_ms} required="required" placeholder="Enter processing_time_ms" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processing_time_ms} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Import_process_logssubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Import_process_logs</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Import Session Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleimport_session_idChange} className="form-control" name="import_session_id" value={this.state.import_session_id} required="required" placeholder="Enter import_session_id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.import_session_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Row Number</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlerow_numberChange} className="form-control" name="row_number" value={this.state.row_number} required="required" placeholder="Enter row_number" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.row_number} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Excel Row Data</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleexcel_row_dataChange} className="form-control" name="excel_row_data" value={this.state.excel_row_data} required="required" placeholder="Enter excel_row_data" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.excel_row_data} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Mapped Data</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemapped_dataChange} className="form-control" name="mapped_data" value={this.state.mapped_data} required="required" placeholder="Enter mapped_data" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.mapped_data} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Validation Errors</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlevalidation_errorsChange} className="form-control" name="validation_errors" value={this.state.validation_errors} required="required" placeholder="Enter validation_errors" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.validation_errors} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Operation Type</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleoperation_typeChange}>
                                          <option defaultValue> Select Operation Type </option>
                                          {this.state.bulkimportoperationtypemaster.map((api, index, idx) => (
                                            <option key={index} value={api.insert}> {api.insert} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.operation_type} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Operation Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handleoperation_statusChange}>
                                          <option defaultValue> Select Operation Status </option>
                                          {this.state.bulkimportoperationstatusmaster.map((api, index, idx) => (
                                            <option key={index} value={api.success}> {api.success} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.operation_status} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Record Id</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlerecord_idChange} className="form-control" name="record_id" value={this.state.record_id} required="required" placeholder="Enter record_id" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.record_id} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Error Code</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleerror_codeChange} className="form-control" name="error_code" value={this.state.error_code} required="required" placeholder="Enter error_code" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_code} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Error Message</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleerror_messageChange} className="form-control" name="error_message" value={this.state.error_message} required="required" placeholder="Enter error_message" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.error_message} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Processing Time Ms</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handleprocessing_time_msChange} className="form-control" name="processing_time_ms" value={this.state.processing_time_ms} required="required" placeholder="Enter processing_time_ms" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.processing_time_ms} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Import_process_logsupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <Button
                        variant="primary"
                        className="bi bi-plus"
                        style={{ float: "right", marginBottom: "10px" }}
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}